module.exports = __webpack_public_path__ + "public/Icons/infoIcon.png?e6100fb1";